import React from 'react';

const Modal: React.FC<{ onClose: () => void; children: React.ReactNode; maxWidth?: string }> = ({
  onClose,
  children,
  maxWidth = 'max-w-lg',
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-coffee-200/50 p-4" onClick={onClose}>
    <div
      className={`w-full ${maxWidth} max-h-[90vh] overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  </div>
);

export default Modal;
